import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Search from '../orderlog/Searchlog';
import '../../assets/css/Orderlog.css'
import Orderlogtable2 from '../Table/Orderlogtable2';

const styles = {};
class OrderLog extends React.Component {

  state = {
    order: null,
  }

  saveStr = (order) => {
    this.setState({
      order
    });
 }

  render() {
    return (
      <div className="ndata">
             <div >
             <Grid container>
                <Grid >
                  <h2 className="ntextOpenOrder">
                      Order Log
                  </h2>
                </Grid>
              </Grid>
              <div style={{ marginTop:"3vh" }}>
                <Search order_no={this.saveStr} />
              </div>
            </div>
           <Orderlogtable2 orderId={this.props.orderId} order={this.state.order} /> 
        </div>
    );
  }
}
export default withStyles(styles)(OrderLog);
